import { Typography, Box } from '@mui/material';

const CustomCommonBox = ({id, label, children}) => {

    return (
        <div>
            <Box key={id} sx={{
                borderRadius: '16px',           // Curved border (change the value to adjust the curve)
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', // Drop shadow
                padding: '12px',                // Optional: Add padding inside the box
                margin: 'auto',                  // Optional: Center the box horizontally
                marginTop: '20px'
            }}>
            <Typography variant="h6" gutterBottom  sx={{ fontSize: '0.875rem', fontWeight: '900' }} >
                {label}
            </Typography>
            {children}
            </Box>
        </div>
    )
}

export default CustomCommonBox